export const downloadFile = (data: any, fileName: string, mimeType: string) => {
    const blob = data instanceof Blob ? data : new Blob([data], { type: mimeType });

    if (blob.size === 0) {
        throw new Error('File is empty');
    }

    const url = window['URL'].createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();

    link.remove();
    window['URL'].revokeObjectURL(url);
};
